export type ordersTypes =
  | 'incomplete'
  | 'pending_approval'
  | 'supplying'
  | 'delivered'
  | 'canceled';

export const tabsConfig: Array<{key: ordersTypes; label: string}> = [
  {key: 'incomplete', label: 'تکمیل نشده'},
  {key: 'pending_approval', label: 'در انتظار تایید'},
  {key: 'supplying', label: 'در حال تامین'},
  {key: 'delivered', label: 'دریافت شده'},
  {key: 'canceled', label: 'لغو شده'},
];
